<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('classAttendance.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('classAttendance.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loadingPreData">
      <ts-card>
        <ts-card-wrapper>
          <form class="form-horizontal">
            <fieldset>
              <legend class="text-black">
                {{ $t('classAttendance.selectCriterial') }}
              </legend>
              <div class="row">
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.date') }}</label
                    >
                    <div class="col-md-8">
                      <a-date-picker
                        :style="{ width: '100%' }"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        v-model="model.att_date"
                        disabled
                      />
                      <div class="validate" v-if="errors.has('att_date')">
                        {{ errors.first('att_date') }}
                      </div>
                    </div>
                    <!-- <div class="col-md-8">
                      <a-date-picker
                        :style="{ width: '100%' }"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        v-model="model.att_date"
                      />
                      <div class="validate" v-if="errors.has('att_date')">
                        {{ errors.first('att_date') }}
                      </div>
                    </div> -->
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.termName') }}</label
                    >
                    <div class="col-md-8">
                      <a-select
                        v-model="model.ac_term_id"
                        style="width: 100%"
                        :placeholder="$t('all')"
                        :options="termOption"
                        show-search
                        @change="getClassByTerm"
                        :class="{ 'is-invalid': errors.has('ac_term_id') }"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                      ></a-select>
                      <div class="validate" v-if="errors.has('ac_term_id')">
                        {{ errors.first('ac_term_id') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.className') }}</label
                    >
                    <div class="col-md-8">
                      <ts-loading-banner :loading="fetchingClass">
                        <a-select
                          v-model="model.class_id"
                          style="width: 100%"
                          :placeholder="$t('all')"
                          :options="classOption || []"
                          @change="getTeacherByClass"
                          :class="{ 'is-invalid': errors.has('class_id') }"
                          show-search
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        />
                        <div class="validate" v-if="errors.has('class_id')">
                          {{ errors.first('class_id') }}
                        </div>
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.teacherName') }}</label
                    >
                    <div class="col-md-8">
                      <ts-loading-banner :loading="fetchingTeacher">
                        <a-select
                          v-model="selectedTeacher"
                          style="width: 100%"
                          :placeholder="$t('all')"
                          :options="teacherOption"
                          @change="onTeacherChange"
                          :class="{ 'is-invalid': errors.has('teacher_id') }"
                          show-search
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          :disabled="teacherDisabled"
                        />
                        <div class="validate" v-if="errors.has('teacher_id')">
                          {{ errors.first('teacher_id') }}
                        </div>
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-3 col-md-6" v-if="hasSchedule">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label required"
                      >{{ $t('classAttendance.subjectName') }}</label
                    >
                    <div class="col-md-8">
                      <ts-loading-banner :loading="fetchingSubject">
                        <a-select
                          v-model="model.subject_id"
                          style="width: 100%"
                          :placeholder="$t('all')"
                          :options="subjectOption"
                          :class="{ 'is-invalid': errors.has('subject_id') }"
                          show-search
                          @change="onSubjectChange"
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          :disabled="!model.teacher_id"
                        />
                        <div class="validate" v-if="errors.has('subject_id')">
                          {{ errors.first('subject_id') }}
                        </div>
                      </ts-loading-banner>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-lg-4 col-md-6">
                  <div class="form-group row">
                    <label
                      class="col-md-4 form-col-label control-label"
                    ></label>
                    <div class="col-md-8">
                      <ts-button
                        @click.prevent="fetchData"
                        color="info"
                        outline
                        :waiting="loading"
                        >{{ $t('search') }}</ts-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </ts-card-wrapper>
        <StudentAttendance :model="model" @saved="fetchData" />
      </ts-card>
    </ts-loading-banner>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import StudentAttendance from './student-attendance.vue'
export default {
  name: 'classAttendaceV2',
  components: {
    StudentAttendance
  },
  data() {
    return {
      loadingPreData: false,
      errors: new Errors(),
      waitingFetch: false,
      classResources: [],
      teacherResources: [],
      subjectResources: [],
      fetchingTeacher: false,
      fetchingClass: false,
      fetchingSubject: false,
      loading: false,
      selectedTeacher: null,
      teacherDisabled: false,
      hasSchedule: false,
      model: {
        att_date: moment().format('DD-MM-YYYY'),
        ac_term_id: null,
        class_id: null,
        subject_id: null,
        teacher_id: null,
        session_id: null,
        student_attendance_list: []
      }
    }
  },
  created() {
    this.getPreData()
  },
  computed: {
    ...mapState('classAttendanceV2', ['termList']),
    termOption() {
      if (this.termList && this.termList.length > 0) {
        return this.termList.map(el => ({
          label: el.term_name,
          value: el.ac_term_id
        }))
      }
      return []
    },

    classOption() {
      if (this.classResources.length > 0) {
        return this.classResources.map(el => {
          const studyTime =
            el.academic_study_time && el.academic_study_time.study_time
              ? el.academic_study_time.study_time
              : ''
          const session =
            el.academic_study_time && el.academic_study_time.session
              ? el.academic_study_time.session
              : ''

          return {
            label: `${el.class_name} | ${studyTime} | ${session}`,
            value: el.class_id
          }
        })
      }
      return []
    },

    subjectOption() {
      return this.subjectResources.map(el => ({
        label: el.subject_name_foreign || el.subject_name_native,
        value: el.subject_id
      }))
    },

    teacherOption() {
      return this.teacherResources.map(el => ({
        label:
          el.full_name_en ||
          [el.fname_foreign, el.lname_foreign].filter(Boolean).join(' '),
        value: el.teacher_id, // just the teacher ID now
        teacher_id: el.teacher_id
      }))
    }
  },
  methods: {
    async getPreData() {
      this.loadingPreData = true
      this.waitingFetch = true
      await this.$store
        .dispatch('classAttendanceV2/dataBeforeCreate')
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loadingPreData = false
        })
    },
    getClassByTerm(ac_term_id) {
      this.teacherDisabled = false
      this.fetchingClass = true
      this.model.class_id = null
      this.model.subject_id = null
      this.hasSchedule = false
      this.selectedTeacher = null
      this.model.student_attendance_list = []

      this.classResources = []
      this.teacherResources = []
      this.subjectResources = []
      this.$store
        .dispatch('classAttendanceV2/getClass', ac_term_id)
        .then(response => {
          this.classResources = response.data
          this.fetchingClass = false
        })
        .catch(error => {
          this.fetchingClass = false
          this.$toasted.error(error.message)
        })
    },
    getSubjectByTeacher(class_id, teacher_id) {
      this.fetchingSubject = true
      this.model.subject_id = null
      this.subjectResources = []
      this.model.student_attendance_list = []
      if (!class_id || !teacher_id) {
        this.fetchingSubject = false
        return
      }
      this.$store
        .dispatch('classAttendanceV2/getSubjectByTeacher', {
          class_id,
          teacher_id
        })
        .then(response => {
          this.subjectResources = response.data
          this.fetchingSubject = false
        })
        .catch(error => {
          this.fetchingSubject = false
          this.$toasted.error(error.message)
        })
    },
    // getTeacherByClass(class_id) {
    //   this.fetchingTeacher = true
    //   this.selectedTeacher = null
    //   this.$store
    //     .dispatch('classAttendanceV2/getTeacher', class_id)
    //     .then(response => {
    //       this.teacherResources = response.data
    //       this.fetchingTeacher = false
    //     })
    //     .catch(error => {
    //       this.fetchingTeacher = false
    //       this.$toasted.error(error.message)
    //     })
    // },
    getTeacherByClass(class_id) {
      const selectedClass = this.classResources.find(
        el => el.class_id === class_id
      )
      this.hasSchedule = !!(selectedClass && selectedClass.has_schedule)

      this.fetchingTeacher = true
      this.selectedTeacher = null
      this.model.teacher_id = null
      this.model.session_id = null
      this.teacherDisabled = false
      this.model.subject_id = null
      this.subjectResources = []
      this.model.student_attendance_list = []
      this.$store
        .dispatch('classAttendanceV2/getTeacher', class_id)
        .then(response => {
          this.teacherResources = response.data
          if (this.teacherResources.length > 0) {
            const firstTeacher = this.teacherResources[0]
            this.$nextTick(() => {
              this.selectedTeacher = firstTeacher.teacher_id
              this.model.teacher_id = firstTeacher.teacher_id
              this.model.session_id = firstTeacher.session_id || null
              this.teacherDisabled = this.teacherResources.length === 1
              if (this.hasSchedule) {
                this.getSubjectByTeacher(
                  this.model.class_id,
                  this.model.teacher_id
                )
              }
            })
          } else {
            this.$toasted.info(this.$t('classAttendance.noTeacherScheduled')) // NEW
          }

          this.fetchingTeacher = false
        })
        .catch(error => {
          this.fetchingTeacher = false
          this.$toasted.error(error.message)
        })
    },

    onTeacherChange(value) {
      const selected = this.teacherOption.find(opt => opt.value === value)
      if (selected) {
        this.model.teacher_id = selected.teacher_id
        this.model.session_id = selected.session_id
      } else {
        this.model.teacher_id = null
        this.model.session_id = null
      }
      this.model.student_attendance_list = []
      if (this.hasSchedule) {
        this.getSubjectByTeacher(this.model.class_id, this.model.teacher_id)
      }
    },

    onSubjectChange() {
      this.model.student_attendance_list = []
    },

    fetchData() {
      this.loading = true
      const formattedDate = this.model.att_date
        ? moment(this.model.att_date, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : null

      // Exclude student_attendance_list using destructuring
      const { student_attendance_list, ...restModel } = this.model

      const param = {
        ...restModel,
        att_date: formattedDate
      }
      this.model.student_attendance_list = []
      this.errors = new Errors()
      this.$store
        .dispatch('classAttendanceV2/fetch', param)
        .then(response => {
          this.model.student_attendance_list = response.data.data
            .map(el => ({
              student_att_id: parseInt(el.student_att_id),
              student_id: parseInt(el.student_id),
              student_name_en: el.student_name_en || el.student_name,
              present: Number(el.present) || 0,
              permission: Number(el.permission) || 0,
              absent: Number(el.absent) || 0,
              late: Number(el.late) || 0,
              comments: el.comments || ''
            }))
            .sort((a, b) => a.student_name_en.localeCompare(b.student_name_en))
        })
        .catch(error => {
          this.model.student_attendance_list = []
          const data =
            error.response && error.response.data ? error.response.data : {}
          if (data.errors) {
            const firstError = Object.values(data.errors)[0][0]
            this.errors = new Errors(data.errors)
            this.$toasted.error(firstError)
          } else {
            this.$toasted.error(data.message || error.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#table-container {
  min-height: 30vh;
  max-height: 50vh;
  overflow-y: scroll;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
hr {
  border: 1px solid #ececec;
}
</style>
